import {
  CHANGE_LOCALE
} from '../actions';
import i18n from '../../services/i18n';
import moment from 'moment';

export const changeLocale = (locale) => {
  localStorage.setItem('currentLanguage', locale);
  i18n.changeLanguage(locale);
  // moment.locale(locale)

  return (
    {
      type: CHANGE_LOCALE,
      payload: locale
    }
  );
};

